// extracted by mini-css-extract-plugin
module.exports = {"container":"grid_container__230cF"};